var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.screened && (_vm.values.a.length > 0 || _vm.screens.a.length > 0))?_c('ValuesChart',{attrs:{"chartData":_vm.chartData,"options":_vm.chartOptions,"width":150,"height":50}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }